//used for input date textField with type "datetime local" ,example: "2017-05-24T10:30"
//Remarks: Dash => example dd-mm-yyy  
//        Slash => example dd/mm/yyyy
export function toDateFormatWithT(date) {
    if (String(date).length > 20) {
        return date
    }
    if (date.includes(' ')) {
        var formattedDate = ""
        let dateArray = date.split(' ')
        if (dateArray[1].length === 7) {
            formattedDate = date.replace(' ', 'T0').substring(0, date.length - 2)
        }
        else {
            formattedDate = date.replace(' ', 'T').substring(0, date.length - 3)
        }

        return formattedDate
    }
    else {
        return date
    }
}

export function toDateFormatWithoutT(date) {
    if (date.includes('T')) {
        var formattedDate = ""
        let dateArray = date.split('T')
        formattedDate = dateArray[0] + " " + dateArray[1] + ":00"
        return formattedDate
    }
    else {
        return date
    }
}

export function fromNewDateFormatToDDMMYYYYSlash(newDate) {
    let addZeroToMonth = false
    let addZeroToDay = false
    if (new Date(newDate).getDate() < 10) {
        addZeroToDay = true
    }
    if (new Date(newDate).getMonth() + 1 < 10) {
        addZeroToMonth = true
    }

    let date = (addZeroToDay ? "0" : "") + new Date(newDate).getDate() + "/" + (addZeroToMonth ? "0" : "") + String(new Date(newDate).getMonth() + 1) + "/" + new Date(newDate).getFullYear();

    return date
}

export function fromNewDateFormatToYYYYMMDDSlash(newDate) {
    let addZeroToMonth = false
    let addZeroToDay = false
    if (new Date(newDate).getDate() < 10) {
        addZeroToDay = true
    }
    if (new Date(newDate).getMonth() + 1 < 10) {
        addZeroToMonth = true
    }

    let date = new Date(newDate).getFullYear() + "/" + (addZeroToMonth ? "0" : "") + String(new Date(newDate).getMonth() + 1) + "/" + (addZeroToDay ? "0" : "") + new Date(newDate).getDate();

    return date
}

export function fromNewDateFormatToYYYYMMDDHHmmssDash(newDate) {

    let addZeroToMonth = false
    let addZeroToDay = false
    let addZeroToHour = false
    let addZeroToMin = false
    let addZeroToSec = false

    if (new Date(newDate).getDate() < 10) {
        addZeroToDay = true
    }

    if (new Date(newDate).getMonth() + 1 < 10) {
        addZeroToMonth = true
    }

    if (new Date(newDate).getHours() < 10) {
        addZeroToHour = true
    }

    if (new Date(newDate).getMinutes() < 10) {
        addZeroToMin = true
    }

    if (new Date(newDate).getSeconds() < 10) {
        addZeroToSec = true
    }

    let date = new Date(newDate).getFullYear() + "-" + (addZeroToMonth ? "0" : "") + String(new Date(newDate).getMonth() + 1) + "-" + (addZeroToDay ? "0" : "") + new Date(newDate).getDate() + " " + (addZeroToHour ? "0" : "") + new Date(newDate).getHours() + ":" + (addZeroToMin ? "0" : "") + new Date(newDate).getMinutes() + ":" + (addZeroToSec ? "0" : "") + new Date(newDate).getSeconds();

    return date
}

export function fromNewDateFormatToDDMMYYYYHHmmssSlash(newDate) {

    let addZeroToMonth = false;
    let addZeroToDay = false;
    let addZeroToHour = false;
    let addZeroToMin = false;
    let addZeroToSec = false;

    if (new Date(newDate).getDate() < 10) {
        addZeroToDay = true;
    }

    if (new Date(newDate).getMonth() + 1 < 10) {
        addZeroToMonth = true;
    }

    if (new Date(newDate).getHours() < 10) {
        addZeroToHour = true;
    }

    if (new Date(newDate).getMinutes() < 10) {
        addZeroToMin = true;
    }

    if (new Date(newDate).getSeconds() < 10) {
        addZeroToSec = true;
    }

    let date = (addZeroToDay ? "0" : "") + new Date(newDate).getDate() + "/" + (addZeroToMonth ? "0" : "") + String(new Date(newDate).getMonth() + 1) + "/" + new Date(newDate).getFullYear() + " " + (addZeroToHour ? "0" : "") + new Date(newDate).getHours() + ":" + (addZeroToMin ? "0" : "") + new Date(newDate).getMinutes() + ":" + (addZeroToSec ? "0" : "") + new Date(newDate).getSeconds();

    return date;
}


export function fromNewDateFormatToHHmmssSlash(newDate) {


    let addZeroToHour = false;
    let addZeroToMin = false;
    let addZeroToSec = false;

    if (new Date(newDate).getHours() < 10) {
        addZeroToHour = true;
    }

    if (new Date(newDate).getMinutes() < 10) {
        addZeroToMin = true;
    }

    if (new Date(newDate).getSeconds() < 10) {
        addZeroToSec = true;
    }

    let date = (addZeroToHour ? "0" : "") + new Date(newDate).getHours() + ":" + (addZeroToMin ? "0" : "") + new Date(newDate).getMinutes() + ":" + (addZeroToSec ? "0" : "") + new Date(newDate).getSeconds();

    return date;
}

export function fromDDMMYYYYHHmmssSlashToYYYYMMDDHHmmssDash(date) {
    let dateArray = date.split('/')
    let days = dateArray[0]
    let months = dateArray[1]
    let years = dateArray[2].substring(0, 3)
    let time = dateArray[2].substring(4, dateArray[2].length - 1)
    return years + "-" + months + "-" + days + time
}

export function configureStartTimeByDuration(duration) {
    let minutes = 0
    let seconds = 0
    let hours = 0
    let timeArray = duration.split(':')
    if (timeArray.length < 3) {
        minutes = parseInt(timeArray[0])
        seconds = parseInt(timeArray[1])
    }
    else {
        hours = parseInt(timeArray[0])
        minutes = parseInt(timeArray[1])
        seconds = parseInt(timeArray[2])
    }
    var startTime = new Date();
    startTime.setHours(startTime.getHours() - hours);
    startTime.setMinutes(startTime.getMinutes() - minutes);
    startTime.setSeconds(startTime.getSeconds() - seconds);
    return startTime
}

